const StickyAudioPlayer = () => {
	const block = document.querySelectorAll(".sticky-audio-player");
	if (!block) {
		return;
	}

	block.forEach((el) => {
		const control = el.querySelector(".sticky-audio-player__control");
		const changeVoiceControl = el.querySelector(".sticky-audio-player__change");
		const track = el.querySelector(".sticky-audio-player__track");
		const videos = document.querySelectorAll("video");
		const voices = el.getAttribute("data-voices").split(',');
		let currentVoice = 0;
		let currentTime = 0;

		if (voices.length > 1) {
			el.classList.add("sticky-audio-player_has-voices");
		}

		const mutedAllVideos = () => {
			videos.forEach(video => {
				const isPromoReel = video.closest(".promo-reel");
				if (isPromoReel) {
					isPromoReel.querySelector(".promo-reel__control").classList.remove("active");
				}

				video.setAttribute("muted", "muted");
				video.muted = true;
			});
		};

		track.addEventListener("play", (e) => {
			el.classList.add("sticky-audio-player_playing");
		});

		track.addEventListener("pause", (e) => {
			el.classList.remove("sticky-audio-player_playing");
		});

		control.addEventListener("click", (e) => {
			track.querySelector("source").setAttribute("src", voices[currentVoice]);
			track.load();

			let isPlaying = el.classList.contains("sticky-audio-player_playing");

			if (isPlaying) {
				track.pause();
			} else {
				mutedAllVideos();
				track.play();
			}
		});

		changeVoiceControl.addEventListener("click", (e) => {
			track.pause();
			currentTime = track.currentTime;
			currentVoice = currentVoice === voices.length - 1 ? 0 : currentVoice + 1;
			track.querySelector("source").setAttribute("src", voices[currentVoice]);
			track.load();

			track.currentTime = currentTime;
			track.play();
		});
	});
};

export default StickyAudioPlayer;